module.exports = __webpack_public_path__ + "static/favicon-ba8288bcd333e3588059706b29a88beb.jpg";